export default {
  'B.C. Lions': {
    displayName: 'B.C. Lions',
    logoUrl: 'cfl/bc_lions.webp',
  },
  'Ottawa Redblacks': {
    displayName: 'OTT Redblacks',
    logoUrl: 'cfl/ottawa_redblacks.webp',
  },
  'Edmonton Elks': {
    displayName: 'EDM Elks',
    logoUrl: 'cfl/edmonton_elks.webp',
  },
  'Winnipeg Blue Bombers': {
    displayName: 'WPG Blue Bombers',
    logoUrl: 'cfl/winnipeg_blue_bombers.webp',
  },
  'Toronto Argonauts': {
    displayName: 'TOR Argonauts',
    logoUrl: 'cfl/toronto_argonauts.webp',
  },
  'Calgary Stampeders': {
    displayName: 'CGY Stampeders',
    logoUrl: 'cfl/calgary_stampeders.webp',
  },
  'Montreal Alouettes': {
    displayName: 'MTL Alouettes',
    logoUrl: 'cfl/montreal_alouettes.webp',
  },
  'Hamilton Tiger-Cats': {
    displayName: 'HAM Tiger-Cats',
    logoUrl: 'cfl/hamilton_tiger_cats.webp',
  },
  'Saskatchewan Roughriders': {
    displayName: 'SSK Roughriders',
    logoUrl: 'cfl/saskatchewan_roughriders.webp',
  },
};
